import cx from 'classnames';
import React from 'react';
import { Input as BaseInput } from 'react-bootstrap';

class Input extends React.Component {
    /**
     * Formats an array of information to pass into the help attribute based on
     * supplied help and any errors built for display.
     *
     * If originalHelp is supplied as an array this method will not modify the
     * help and just prepend the error help entries, if it is not an array we
     * put it into an element in an array then prepend errors.
     */
    static buildHelp (originalHelp, errors) {
        if (!errors.length) {
            return originalHelp;
        }

        var help = Array.isArray(originalHelp) ?
            originalHelp :
            [<div key="help">{originalHelp}</div>];

        return errors.concat(help);
    }

    /**
     * Returns errors formatted with p tags that match the provided error path.
     */
    static filterErrors (errors, errorPath) {
        if (null === errorPath) {
            return [];
        }

        return errors.filter((error) => {
            return error.path == errorPath;
        }).map((error, i) => {
            return <div key={i}>{error.message}</div>
        });
    }

    /**
     * Calculates some attributes used for passing to the base Input object.
     *
     *  * bsStyle
     *  * hasFeedback
     *  * help
     */
    calculateAttrs = () => {
        var { bsStyle, errorPath, errors, hasFeedback, help } = this.props;
        errors = Input.filterErrors(errors, errorPath);
        help = Input.buildHelp(help, errors);

        if (null == bsStyle && errors.length) {
            bsStyle = 'error';
        }
        if (null == hasFeedback && errors.length) {
            hasFeedback = true;
        }

        return { bsStyle, hasFeedback, help };
    }

    getValue () {
        return this.refs.input.getValue();
    }

    render () {
        const { errorPath, errors, help, labelClassName, required, ...props } = this.props;
        const inputAttrs = this.calculateAttrs();

        return <BaseInput ref="input"
            labelClassName={cx(labelClassName, { required: required })}
            {...inputAttrs}
            {...props}
        />;
    }
}
Input.propTypes = {
    errorPath: React.PropTypes.string,
    errors: React.PropTypes.arrayOf(React.PropTypes.object),
    required: React.PropTypes.bool
};
Input.defaultProps = {
    errorPath: null,
    errors: [],
    required: false
};

export default Input;



// WEBPACK FOOTER //
// ./app/components/Form/Input.js